module.exports = __webpack_public_path__ + "img/SpecialGuests.c98d1e15.png";